import {
  Table,
  Tag,
  Popconfirm,
  Pagination,
  Tooltip,
  notification,
  Button,
  message,
  Image,
  Spin,
  Switch,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import { IoTrashOutline } from "react-icons/io5";
import axios from "../../../config/axiosInstance";
import { API } from "../../../config/API";
import { s3FallbackUrl } from "../../../utils/mediaFallback";
import { useSelector } from "react-redux";
import moment from "moment";
import { BiEdit } from "react-icons/bi";
import { LuUndo2 } from "react-icons/lu";
import { useState } from "react";
import "../styles.css";

function DataTable(props: any) {
  const User = useSelector((state: any) => state.User.user);
  const [Notifications, contextHolder] = notification.useNotification();
  const [loadingRows, setLoadingRows] = useState<{ [key: number]: boolean }>({});

  interface DataType {
    key: string;
    id: number;
    media: string;
    permalink: string;
    createdAt: string;
    publishedAt: string;
    tags: any[];
    user: any;
    is_deleted: boolean;
  }

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 50,
      align: "left",
      render: (text, record, index) => {
        return <div>{index + 1}</div>;
      },
    },
    {
      title: "Photos",
      key: "media",
      dataIndex: "media",
      align: "center",
      render: (text, record: any) => {
        return (
          <div style={{ cursor: "pointer", display: "flex", justifyContent: "center" }}>
            {record.media ? (
              <Image
                key={record.media}
                src={record.media}
                style={{ width: 70, borderRadius: 6 }}
                alt="Table Image"
                fallback={s3FallbackUrl(record.media) || undefined}
              />
            ) : (
              <div className="homescreen-table-NoImg">No media</div>
            )}
          </div>
        );
      },
    },
    {
      title: "Headline",
      dataIndex: "permalink",
      key: "permalink",
      width: 400,
      align: "left",
      render: (text, record: any) => {
        return (
          <div
            style={{ cursor: "pointer", fontSize: 13, fontWeight: 500 }}
            onClick={() => props.onEdit(record)}
          >
            {record.permalink || "Highlight"}
          </div>
        );
      },
    },
    {
      title: "Created By",
      dataIndex: "user",
      key: "user",
      width: 180,
      align: "left",
      render: (user: any) => {
        return (
          <div style={{ fontSize: "12px" }}>
            {user?.username || user?.attributes?.username || "N/A"}
          </div>
        );
      },
    },
    {
      title: "Created Date & Time",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      align: "left",
      render: (text, record: any) => {
        return (
          <div
            style={{ cursor: "pointer", fontSize: 12 }}
            onClick={() => props.onEdit(record)}
          >
            {moment(record?.createdAt).format("DD-MM-YYYY-h:mm A")}
          </div>
        );
      },
    },
    {
      title: "Published At",
      dataIndex: "publishedAt",
      key: "publishedAt",
      width: 200,
      align: "left",
      render: (text, record: any) => {
        return (
          <div
            style={{ cursor: "pointer", fontSize: 12 }}
            onClick={() => props.onEdit(record)}
          >
            {record?.publishedAt ? (
              moment(record?.publishedAt).format("DD-MM-YYYY-h:mm A")
            ) : (
              <span style={{ color: "red" }}>{"Not Published"}</span>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      key: "publishedAt",
      width: 140,
      align: "center",
      render: (text, record: any) => {
        const isPublished = !!record?.publishedAt && !record?.is_deleted;
        const isLoading = loadingRows[record.id] || false;
        
        if (record?.is_deleted === true) {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Tag color="red" style={{ fontSize: "10px", margin: 0 }}>
                trash
              </Tag>
            </div>
          );
        }
        
        return (
          <div 
            className="highlights-toggle-switch"
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <Tooltip title={isPublished ? "Click to unpublish" : "Click to publish"}>
              <Switch
                checked={isPublished}
                loading={isLoading}
                disabled={isLoading}
                size="small"
                checkedChildren={<span style={{ fontSize: "10px", transition: "opacity 200ms ease-in-out" }}>Published</span>}
                unCheckedChildren={<span style={{ fontSize: "10px", transition: "opacity 200ms ease-in-out" }}>Draft</span>}
                style={{ 
                  minWidth: "60px"
                }}
                className="highlights-smooth-switch"
                onChange={(checked) => {
                  if (props.onTogglePublish) {
                    setLoadingRows((prev) => ({ ...prev, [record.id]: true }));
                    props.onTogglePublish(record, checked, () => {
                      setLoadingRows((prev) => {
                        const newState = { ...prev };
                        delete newState[record.id];
                        return newState;
                      });
                    });
                  }
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Task",
      key: "action",
      width: 180,
      align: "center",
      render: (_, record: any) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Tooltip title="Edit">
              <BiEdit
                size={18}
                color="#f5a442"
                style={{ cursor: "pointer" }}
                onClick={() => props.onEdit(record)}
              />
            </Tooltip>
            <Tooltip
              title={`${
                record.is_deleted === true ? "Recover" : "Move"
              } From Trash`}
              color={"black"}
            >
              {record.is_deleted === true ? (
                <LuUndo2
                  color="blue"
                  size={18}
                  style={{ cursor: "pointer" }}
                  onClick={() => props.unTrash && props.unTrash(record)}
                />
              ) : (
                <IoTrashOutline
                  color="red"
                  size={18}
                  style={{ cursor: "pointer" }}
                  onClick={() => props.onDelete(record)}
                />
              )}
            </Tooltip>
            {record.is_deleted === true && User?.role?.id === 4 && (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => onDeleteItem(record.id)}
              >
                <Button size="small" danger style={{ fontSize: 11, padding: "0 8px" }}>
                  Remove
                </Button>
              </Popconfirm>
            )}
          </div>
        );
      },
    },
  ];

  const onDeleteItem = (id: any) => {
    let url = API.BASE_URL + API.HIGHLIGHTS + `/${id}`;
    axios
      .delete(url)
      .then((response) => {
        Notifications["success"]({
          message: `Successfully deleted`,
        });
        props.refresh();
      })
      .catch((err) => {
        console.error("Error deleting highlight:", err);
        Notifications["error"]({
          message: `Oops! Something went wrong`,
        });
      });
  };

  return (
    <div style={{ marginTop: 10 }}>
      <style>
        {`
          .highlights-toggle-switch .ant-switch-handle,
          .highlights-smooth-switch .ant-switch-handle {
            transition: left 300ms cubic-bezier(0.4, 0, 0.2, 1) !important;
            will-change: left !important;
          }
          .highlights-toggle-switch .ant-switch-checked .ant-switch-handle,
          .highlights-smooth-switch.ant-switch-checked .ant-switch-handle {
            transition: left 300ms cubic-bezier(0.4, 0, 0.2, 1) !important;
            will-change: left !important;
          }
        `}
      </style>
      {contextHolder}
      <Table
        columns={columns}
        dataSource={props.data}
        className="commen-table-custom-scrollbar"
        pagination={false}
        size="small"
        rowKey={(record: any) => String(record?.id || Math.random())}
      />
      <br />
      <div style={{ float: "right" }}>
        {props.loading ? (
          <Spin size="small" />
        ) : (
          <Pagination
            responsive
            current={props?.page}
            total={props.meta && props.meta}
            pageSize={props?.pagesize}
            onChange={(p, t) => {
              props.onPageChange(p, t);
            }}
          />
        )}
      </div>
    </div>
  );
}

export default DataTable;

